import type { RuneGrabConfig, TargetApp } from './types.js';

const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);

export const DEFAULTS: Required<RuneGrabConfig> = {
  shortcut: isMac ? 'Meta+Shift+G' : 'Ctrl+Shift+G',
  target: 'clipboard',
  accentColor: '#f5f5f5',
  maxStackDepth: 3,
  onGrab: () => { },
  onToggle: () => { },
  showTargetPicker: true,
  skipComponents: [],
};

export const s = {
  initialized: false,
  active: false,
  locked: false,
  promptMode: false,
  menuExpanded: false,
  targetsExpanded: false,
  grabType: 'screenshot' as 'screenshot' | 'reference',
  autoPasteEnabled: false,
  helperAvailable: false,
  helperChecking: false,
  dockedEdge: null as 'top' | 'bottom' | 'left' | 'right' | null,
  selectedElement: null as Element | null,
  mmRAF: 0,
  config: { ...DEFAULTS } as Required<RuneGrabConfig>,
  customSkipSet: undefined as Set<string> | undefined,
  miniMenu: null as HTMLDivElement | null,
  overlay: null as HTMLDivElement | null,
  label: null as HTMLDivElement | null,
  toolbar: null as HTMLDivElement | null,
  cursorStyle: null as HTMLStyleElement | null,
  selectionBox: null as HTMLDivElement | null,
  ssDrawing: false,
  ssStartX: 0,
  ssStartY: 0,
  lastMouseX: 0,
  lastMouseY: 0,
  dragging: false,
  dragPending: false,
  dragStartX: 0,
  dragStartY: 0,
  hasDragged: false,
  dragW: 0,
  dragH: 0,
  dragBaseX: 0,
  dragBaseY: 0,
  dragPointerId: -1,
  dragLastX: 0,
  dragLastY: 0,
};
